import React from "react";

interface TypographyProps {
  headline: string;
  fontFamily: string;
  fontSize: string;
  letterSpacing: string;
  lineHeight: string;
  textColor: string;
}

interface PortfolioTypographyProps {
  typographyData: TypographyProps[];
  primaryColor?: string;
}

interface IconProps {
  color: string;
}

// Reusable SVG Icon component
const TypographyIcon: React.FC<IconProps> = ({ color }) => (
  <svg
    width="40"
    height="46"
    viewBox="0 0 46 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 5.26519C0 3.22573 1.2668 1.49175 3.21641 0.862843C3.83633 0.665188 5.14805 0.638233 5.79492 0.817921C6.50469 1.00659 7.17852 1.39292 7.74453 1.93198C8.39141 2.54292 8.73281 3.08198 8.99336 3.85464L9.19102 4.46558H23H36.809L37.0066 3.85464C37.2672 3.08198 37.6086 2.54292 38.2555 1.93198C39.1629 1.06948 40.1152 0.692139 41.427 0.692139C43.0531 0.692139 44.3918 1.41987 45.2902 2.79448C45.7844 3.54019 46 4.30386 46 5.26519C46 6.5769 45.6227 7.52925 44.7602 8.43667C44.1492 9.08355 43.6102 9.42495 42.8375 9.6855L42.2266 9.88316V23.6921V37.5011L42.8375 37.6988C43.6102 37.9593 44.1492 38.3007 44.7602 38.9476C45.6227 39.855 46 40.8074 46 42.1191C46 43.7453 45.2723 45.0839 43.8977 45.9824C43.152 46.4765 42.3883 46.6921 41.427 46.6921C40.1152 46.6921 39.1629 46.3148 38.2555 45.4523C37.6086 44.8414 37.2672 44.3023 37.0066 43.5296L36.809 42.9187H23H9.19102L8.99336 43.5207C8.73281 44.3023 8.39141 44.8414 7.74453 45.4523C6.83711 46.3148 5.88477 46.6921 4.57305 46.6921C3.61172 46.6921 2.84805 46.4765 2.10234 45.9824C0.727734 45.0839 0 43.7453 0 42.1191C0 40.8074 0.377344 39.855 1.23984 38.9476C1.85078 38.3007 2.38984 37.9593 3.1625 37.6988L3.77344 37.5011V23.6921V9.88316L3.17148 9.6855C2.38984 9.42495 1.85078 9.08355 1.23984 8.43667C0.377344 7.52925 0 6.5769 0 5.26519ZM40.0523 9.73042C38.6059 9.30816 37.2852 7.94253 36.9258 6.50503L36.818 6.08276L30.1965 6.10073C26.5578 6.1187 20.3406 6.13667 16.3785 6.14566L9.17305 6.17261L9.03828 6.64878C8.61602 8.09526 7.25039 9.40698 5.80391 9.77534L5.36367 9.88316L5.41758 18.9125C5.45352 23.8808 5.48047 30.098 5.48047 32.7304V37.5191L5.95664 37.6539C7.40312 38.0761 8.71484 39.4328 9.0832 40.8882L9.19102 41.3285L19.1637 41.2746C24.6531 41.2386 30.8703 41.2117 32.9816 41.2117H36.827L36.9617 40.7355C37.384 39.289 38.7406 37.9773 40.1961 37.6089L40.6363 37.5011L40.5824 28.4718C40.5465 23.5035 40.5195 17.2863 40.5195 14.6539V9.86518L40.0523 9.73042ZM10.1433 9.37096C10.2601 9.24518 10.4398 9.12838 10.5476 9.11041C10.6464 9.08346 16.3245 9.07447 23.1527 9.08346L35.578 9.09245L35.8206 9.34401L36.0722 9.58659V13.369V17.1514L35.8206 17.3671C35.6589 17.5108 35.4612 17.5827 35.2456 17.5827C34.9491 17.5827 34.7874 17.4479 33.2511 15.9385C32.128 14.8424 31.4362 14.2315 31.1308 14.0788C30.6905 13.8631 30.6277 13.8542 28.3546 13.8272C27.0698 13.8092 25.9288 13.8182 25.812 13.8542C25.75 13.8688 25.696 13.8754 25.6491 13.8972C25.3221 14.0487 25.3359 14.9356 25.3359 24.4108V34.3835H28.5163H31.7058L31.9573 34.5991L32.2089 34.8147V36.7194V38.6241L31.9573 38.8397L31.7058 39.0553H22.9999H14.2941L14.0425 38.8397L13.7909 38.6241V36.7194V34.8147L14.0425 34.5991L14.2941 34.3835H17.4835H20.664V24.4108C20.664 14.9356 20.6777 14.0487 20.3507 13.8972C20.3038 13.8754 20.2498 13.8688 20.1878 13.8542C20.071 13.8182 18.93 13.8092 17.6452 13.8272C15.3722 13.8542 15.3093 13.8631 14.8691 14.0788C14.5636 14.2315 13.8718 14.8424 12.7487 15.9385C11.2124 17.4479 11.0507 17.5827 10.7542 17.5827C10.5386 17.5827 10.3409 17.5108 10.1792 17.3671L9.92765 17.1514V13.378V9.60455L10.1433 9.37096Z"
      fill={color}
    />
  </svg>
);

const PortfolioTypography: React.FC<PortfolioTypographyProps> = ({
  typographyData,
  primaryColor = "#2c2d2c",
}) => {
  return (
    <div className="py-6 md:py-12 w-full xl:w-[95%]">
      <div id="typography" className="flex gap-4 border-b border-gray-400 items-center py-2 pl-2  md:pl-8">
        <TypographyIcon color={primaryColor} />
        <h3 className="text-[2rem] md:text-[3rem]">TYPOGRAPHY</h3>
      </div>
      <div className="flex px-2 md:px-12 py-8 flex-col gap-16">
        <h2 className="text-[2.75rem] md:text-[3.75rem]">Headlines</h2>
        <div className="flex flex-col gap-32">
          {typographyData.map((typography, index) => (
            <div key={index} className="flex flex-col gap-4">
              <div
                className="flex items-center justify-between"
                style={{ color: primaryColor }}
              >
                <p
                  className="text-[12px] md:text-[14px] text-center text-gray-500"
                  style={{ color: primaryColor }}
                >
                  {typography.fontFamily}
                </p>
                |
                <p
                  className="text-[12px] md:text-[14px] text-center text-gray-500"
                  style={{ color: primaryColor }}
                >
                  Size {typography.fontSize}
                </p>
                |
                <p
                  className="text-[12px] md:text-[14px] text-center text-gray-500"
                  style={{ color: primaryColor }}
                >
                  Letter spacing {typography.letterSpacing}
                </p>
                |
                <p
                  className="text-[12px] md:text-[14px] text-center  text-gray-500"
                  style={{ color: primaryColor }}
                >
                  Line Height {typography.lineHeight}
                </p>
              </div>
              <p
                className="text-[#086CF2]"
                style={{
                  fontFamily: `${typography.fontFamily}, sans-serif`,
                  fontSize: typography.fontSize,
                  letterSpacing: typography.letterSpacing,
                  lineHeight: typography.lineHeight,
                  color: typography.textColor,
                }}
              >
                {typography.headline}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PortfolioTypography;
